const notificationsAPIBaseURL =
    process.env.REACT_APP_NOTIFICATIONS_API_BASE_URL || ''
const feedbackAPIBaseURL =
    process.env.REACT_APP_FEEDBACK_TOOLS_API_BASE_URL || ''
const feedbackAPIURL = process.env.REACT_APP_FEEDBACK_TOOLS_API_URI || ''
const notificationAPIURL = process.env.REACT_APP_NOTIFICATIONS_API_URI || ''

export const feedbackEndpoints = {
    postFeedbackEndpoint: `${feedbackAPIBaseURL}${feedbackAPIURL}/`,
    getFeedbackListEndpoint: `${feedbackAPIBaseURL}${feedbackAPIURL}/`,
}

export const notificationsEndpoints = {
    getAllNotificationsEndpoint: `${notificationsAPIBaseURL}${notificationAPIURL}/0`,
    postNotificationEndpoint: `${notificationsAPIBaseURL}${notificationAPIURL}/`,
    pathNotificationAsReadEndpoint: `${notificationsAPIBaseURL}${notificationAPIURL}/markAsRead`,
}

export type Notification = {
    id: string
    title: string
    description: string
    link: string
    from: string
    recipient: string
    priority: number
    category: string
    triggerDate: Date
    validThru: Date
    read?: boolean
}

export type Feedback = {
    identifier: string
    type: 'positive' | 'negative' | 'comment'
    comment?: string
    userEmail?: string
}

export const callSendNotification = async (
    accessToken: string,
    notification: Notification,
) => {
    if (!notificationsAPIBaseURL) {
        return null
    }

    return fetch(notificationsEndpoints.postNotificationEndpoint, {
        method: 'POST',
        headers: {
            Authorization: accessToken,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(notification),
    })
        .then(response => response.json())
        .catch(error => console.log(error))
}

export const callGetAllNotifications = async (
    accessToken: string,
): Promise<Notification[]> => {
    if (!notificationsAPIBaseURL) {
        return []
    }

    try {
        const response = await fetch(
            notificationsEndpoints.getAllNotificationsEndpoint,
            {
                method: 'GET',
                headers: {
                    Authorization: accessToken,
                },
            },
        )

        if (!response.ok) {
            return []
        }

        const notifications: unknown = await response.json()
        return Array.isArray(notifications) ? notifications : []
    } catch (error) {
        console.log(error)
        return []
    }
}

export const callMarkNoficationAsRead = async (
    accessToken: string,
    notificationId: string,
) => {
    if (!notificationsAPIBaseURL) {
        return null
    }

    return fetch(notificationsEndpoints.pathNotificationAsReadEndpoint, {
        method: 'PATCH',
        headers: {
            Authorization: accessToken,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ notificationId }),
    })
        .then(response => response.json())
        .catch(error => console.log(error))
}

export const callFeedbackList = async (accessToken: string) => {
    if (!feedbackAPIBaseURL) {
        return null
    }

    return fetch(feedbackEndpoints.getFeedbackListEndpoint, {
        method: 'GET',
        headers: {
            Authorization: accessToken,
        },
    })
        .then(response => response.json())
        .catch(error => console.log(error))
}

export const callPostFeedback = async (
    accessToken: string,
    feedback: Feedback,
) => {
    if (!feedbackAPIBaseURL) {
        return null
    }

    return fetch(feedbackEndpoints.postFeedbackEndpoint, {
        method: 'POST',
        headers: {
            Authorization: accessToken,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(feedback),
    })
        .then(response => response.json())
        .catch(error => console.log(error))
}
